var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_20184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3896 5.99947C21.3363 4.17538 19.8215 2.66066 17.9973 1.60754C16.1732 0.554421 14.1039 0 11.9976 0C9.89126 0 7.82202 0.554421 5.99785 1.60754C4.17369 2.66066 2.65885 4.17538 1.60559 5.99947L2.32559 18.9595L22.3896 5.99947Z",
    fill: "url(#paint0_linear_840_20184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.804 15L1.608 6C0.554793 7.82421 0.000318554 9.89351 0.000305176 11.9999C0.000291798 14.1063 0.55474 16.1756 1.60792 17.9999C2.66111 19.8241 4.17592 21.3389 6.00011 22.3922C7.8243 23.4454 9.89359 23.9999 12 24L23.76 12L6.804 15Z",
    fill: "url(#paint1_linear_840_20184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.196 15L12 24C14.1062 23.9995 16.1752 23.4447 17.9991 22.3913C19.8229 21.3379 21.3374 19.823 22.3903 17.9988C23.4432 16.1747 23.9974 14.1055 23.9973 11.9993C23.9972 9.89311 23.4427 7.82403 22.3896 6H12L17.196 15Z",
    fill: "url(#paint2_linear_840_20184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18C12.7879 18 13.5681 17.8448 14.2961 17.5433C15.0241 17.2417 15.6855 16.7998 16.2426 16.2426C16.7998 15.6855 17.2417 15.0241 17.5433 14.2961C17.8448 13.5681 18 12.7879 18 12C18 11.2121 17.8448 10.4319 17.5433 9.7039C17.2417 8.97595 16.7998 8.31451 16.2426 7.75736C15.6855 7.20021 15.0241 6.75825 14.2961 6.45672C13.5681 6.15519 12.7879 6 12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.752C12.624 16.752 13.242 16.6291 13.8185 16.3903C14.395 16.1515 14.9189 15.8015 15.3602 15.3602C15.8014 14.919 16.1515 14.3951 16.3903 13.8186C16.6291 13.242 16.752 12.6241 16.752 12C16.752 11.376 16.6291 10.7581 16.3903 10.1815C16.1515 9.605 15.8014 9.08114 15.3602 8.63988C14.9189 8.19861 14.395 7.84858 13.8185 7.60977C13.242 7.37096 12.624 7.24805 12 7.24805C10.7397 7.24805 9.53099 7.7487 8.63981 8.63988C7.74864 9.53105 7.24799 10.7397 7.24799 12C7.24799 13.2604 7.74864 14.469 8.63981 15.3602C9.53099 16.2514 10.7397 16.752 12 16.752Z",
    fill: "#1A73E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_840_20184",
    x1: 1.60799,
    y1: 7.49947,
    x2: 22.3896,
    y2: 7.49947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_840_20184",
    x1: 13.2984,
    y1: 23.2488,
    x2: 2.9064,
    y2: 5.2488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_840_20184",
    x1: 10.248,
    y1: 24,
    x2: 20.64,
    y2: 6.0312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_20184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/Chrome.981177235241bea8fe06e53043f53fea.svg";
export { ForwardRef as ReactComponent };